import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent {
  get isAdmin(): boolean {
    return localStorage.getItem('is_admin') === 'true';
  }

  get isSuperAdmin(): boolean {
    return localStorage.getItem('is_super_admin') === 'true';
  }
}
